import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Classes from "./Settings.module.css";
import Sidebar from "./Components/Sidebar/Sidebar";
import Profile from "./Components/Profile/Profile";
import Preferences from "./Components/Preferences/Preferences";
import { useSelector } from "react-redux";

export default function Settings() {
    const navigateTo = useNavigate();
    const [activeTab, setActiveTab] = useState("profile");
    const companyInfo = useSelector((state) => state.companyInfo?.info);
    const [colorScheme, setcolorScheme] = useState(companyInfo?.color);
    const { profile } = useParams();

    return (
        <div className={Classes.container}>
             <Profile settingsMenu={profile} />

        </div>
    );
}